import { DateTime } from 'luxon'

import { Comment as CommentBase } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import type { CommentModel } from '@models/types'

import useComment from '@hooks/useComment'
import { useRelations as useUserRelations } from '@hooks/useUser'

interface CommentProps {
  boxProps?: object,
  comment: Partial<CommentModel>,
  isLastComment: boolean,
}

const Comment = (props: CommentProps) => {
  const { boxProps, comment, isLastComment } = props

  const commentPayload = useComment(comment)
  const { comment: { body, public: isPublic }, user } = commentPayload

  const { image } = useUserRelations(user)

  const createdDateString = digObject(comment, 'dates.created.date_time')

  return (
    <CommentBase
      boxProps={{
        borderBottom: isLastComment ? 'none' : '1px dashed',
        marginBottom: isLastComment ? 0 : 'large',
        ...boxProps,
      }}
      // @ts-expect-error TS2322
      commentBody={body}
      commentTime={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
      fullName={user.full_name}
      // @ts-expect-error TS2339
      imageUrl={image.thumb_url}
      // @ts-expect-error TS2322
      isPublic={isPublic}
    />
  )
}

export default Comment
